<template>
    <div class="space-y-6">
        <!-- 后台刮削总开关 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    后台刮削设置
                    <div class="tooltip tooltip-bottom ml-2" data-tip="立即执行一次" @click="handleBackendExe">
                        <button class="btn btn-circle btn-ghost btn-xs text-primary">
                            <svg-icon name="backend-exe" class="w-4 h-4 cursor-pointer fill-current" />
                        </button>
                    </div>
                </h2>
                
                <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                    <div class="form-control">
                        <label class="label cursor-pointer justify-start gap-4">
                            <span class="label-text font-medium">开启后台刮削</span>
                            <input type="checkbox" class="toggle toggle-primary toggle-lg" v-model="formData.is_watch_file"
                                @change="updateSys('is_watch_file')" />
                        </label>
                        <div class="mt-2 p-3 bg-info/10 rounded-lg border border-info/20" v-if="celeryTaskLastTime && formData.is_watch_file">
                            <div class="text-sm text-base-content/80 flex items-center">
                                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                上次刮削时间: {{ celeryTaskLastTime }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 监控目录设置 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
                    </svg>
                    监控目录配置
                    <div class="dropdown">
                        <div tabindex="0" role="button" class="btn btn-circle btn-ghost btn-xs text-info ml-2">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <div tabindex="0" class="card compact dropdown-content bg-base-100 rounded-box z-[1] w-[600px] shadow-xl border border-base-200">
                            <div tabindex="0" class="card-body">
                                <h3 class="card-title text-base">配置帮助</h3>
                                <div class="space-y-4">
                                    <div class="bg-primary/5 rounded-lg p-4 border border-primary/20">
                                        <div class="font-bold text-primary mb-2">/app/download:</div>
                                        <div class="text-sm text-base-content/80 mb-2">
                                            部署Docker应用时，需额外映射一个自定义目录到此路径，用于后台刮削监控的目录。
                                        </div>
                                        <div class="bg-base-200 p-2 rounded text-sm">
                                            例如：<span class="text-accent font-medium">&lt;宿主机上新建的自定义目录&gt;</span>:/app/download
                                        </div>
                                    </div>
                                    
                                    <div class="bg-secondary/5 rounded-lg p-4 border border-secondary/20">
                                        <div class="font-bold text-secondary mb-2">/app/media/download:</div>
                                        <div class="text-sm text-base-content/80 mb-2">
                                            项目部署时已映射<span class="text-accent font-medium">&lt;音乐媒体库目录&gt;</span>:/app/media, 
                                            只需在<span class="text-accent font-medium">&lt;音乐媒体库目录&gt;</span>路径下创建一个名为download的目录。
                                        </div>
                                        <div class="bg-base-200 p-2 rounded text-sm">
                                            例如：<span class="text-accent font-medium">&lt;音乐媒体库目录&gt;</span>/download
                                        </div>
                                    </div>

                                    <div class="bg-warning/10 p-4 rounded-lg border border-warning/20">
                                        <div class="font-bold text-warning mb-2">重要提示：</div>
                                        <ul class="list-disc list-inside text-sm text-base-content/80 space-y-1">
                                            <li>/app/download 需要重新部署在部署命令里添加</li>
                                            <li>/app/media/download 无需重新部署</li>
                                            <li>宿主目录不支持中文</li>
                                            <li>/app/download目录和/app/media目录不能重合！</li>
                                            <li>容器内地址/app/download不可修改，需保持一致！</li>
                                            <li>一般用做新下载的音乐文件目录，不要把媒体库都放在这个目录下</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </h2>
                
                <div class="space-y-4">
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text font-medium">监控目录（容器内地址）</span>
                        </label>
                        <div class="flex flex-wrap gap-2">
                            <button class="btn btn-outline btn-sm" @click="redirectEditDetail('/app/download/')">
                                <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
                                </svg>
                                /app/download/
                            </button>
                            <button class="btn btn-outline btn-sm" @click="redirectEditDetail('/app/media/download/')">
                                <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
                                </svg>
                                /app/media/download/
                            </button>
                        </div>
                        <label class="label">
                            <span class="label-text-alt text-base-content/70">后台刮削的监控目录，会对该目录下新增的音乐文件进行以下一系列操作，每 3 分钟扫描一次</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <!-- 音乐预处理 -->
        <li class="font-medium text-xl ml-2">Step 1</li>
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="collapse collapse-arrow">
                <input type="checkbox" v-model="preDataCollapse" @click.stop />
                <div class="collapse-title card-title text-lg font-semibold flex items-center" @click.stop="toggleCollapse('preDataCollapse')">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                    </svg>
                    音乐预处理
                </div>
                <div class="collapse-content card-body pt-0">
                    <div class="space-y-3">
                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4 p-4 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="checkbox" class="checkbox checkbox-primary" 
                                    v-model="formData.is_voiceprint" @change="updateSys('is_voiceprint')" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content">声纹识别</div>
                                    <div class="text-sm text-base-content/70 mt-1">
                                        当音乐文件缺少艺术家或专辑元数据时, 使用声纹识别进行预匹配
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4 p-4 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="checkbox" class="checkbox checkbox-primary" 
                                    v-model="formData.is_fix_encoding" @change="updateSys('is_fix_encoding')" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content">乱码修复</div>
                                    <div class="text-sm text-base-content/70 mt-1">
                                        对标题、艺术家、专辑名进行乱码修复
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4 p-4 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="checkbox" class="checkbox checkbox-primary" 
                                    v-model="formData.is_tran_sim" @change="updateSys('is_tran_sim')" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content">繁体转简体</div>
                                    <div class="text-sm text-base-content/70 mt-1">
                                        将繁体标题、艺术家、专辑名转换为简体，如本来就是简体，则不会进行转换
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 音乐自动刮削 -->
        <li class="font-medium text-xl ml-2">Step 2</li>
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="collapse collapse-arrow">
                <input type="checkbox" v-model="autoModCollapse" @click.stop />
                <div class="collapse-title card-title text-lg font-semibold flex items-center" @click.stop="toggleCollapse('autoModCollapse')">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"></path>
                    </svg>
                    音乐自动刮削
                </div>
                <div class="collapse-content card-body pt-0">
                    <div class="space-y-3">
                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4 p-4 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="checkbox" class="checkbox checkbox-secondary" 
                                    v-model="formData.auto_mod" @change="updateSys('auto_mod')" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content flex items-center">
                                        自动刮削
                                        <div class="tooltip tooltip-bottom ml-2" data-tip="配置自动刮削参数" @click.stop="openAutoModConfig">
                                            <button class="btn btn-circle btn-ghost btn-xs text-primary">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="text-sm text-base-content/70 mt-1">
                                        可自动从音乐流媒体平台搜索元数据实行刮削操作
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4 p-4 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="checkbox" class="checkbox checkbox-secondary" 
                                    v-model="formData.manual_mod" @change="updateSys('manual_mod')" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content flex items-center">
                                        手动刮削
                                        <div class="tooltip tooltip-bottom ml-2" data-tip="配置手动刮削参数" @click.stop="openManualModConfig">
                                            <button class="btn btn-circle btn-ghost btn-xs text-primary">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="text-sm text-base-content/70 mt-1">
                                        可自定义修改音乐元数据中的内容，例如：重命名文件、导出歌词文件、导出封面图片等
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 音乐文件整理 -->
        <li class="font-medium text-xl ml-2">Step 3</li>
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="collapse collapse-arrow">
                <input type="checkbox" v-model="tidyCollapse" @click.stop />
                <div class="collapse-title card-title text-lg font-semibold flex items-center" @click.stop="toggleCollapse('tidyCollapse')">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8l4 4m0-8l4 4-4 4m6 0v12m0 0l4-4-4-4m0 8l-4-4 4-4"></path>
                    </svg>
                    音乐文件整理
                    <div class="badge badge-accent badge-sm ml-2">必选</div>
                </div>
                <div class="collapse-content card-body pt-0">
                    <div class="space-y-3">
                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4 p-4 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="radio" name="radio-1" class="radio radio-accent" 
                                    value='tidy' v-model="formData.tidy_music" @change="updateSys('tidy_music')" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content flex items-center">
                                        整理文件
                                        <div class="tooltip tooltip-bottom ml-2" data-tip="配置整理文件参数" @click.stop="openTidyMusicConfig">
                                            <button class="btn btn-circle btn-ghost btn-xs text-primary">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="text-sm text-base-content/70 mt-1">
                                        将文件以规定的格式整理到统一目录下
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4 p-4 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="radio" name="radio-1" class="radio radio-accent" 
                                    value='move' v-model="formData.tidy_music" @change="updateSys('tidy_music')" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content">转移文件</div>
                                    <div class="text-sm text-base-content/70 mt-1">
                                        将文件以源目录层级转移到固定completed或failed目录下
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 自动刮削抽屉 -->
        <div class="drawer drawer-end">
            <input id="auto-mod" type="checkbox" class="drawer-toggle" v-model="isOpenAutoMod" />
            <div class="drawer-content">
            </div>
            <div class="drawer-side" style="z-index: 1000;">
                <label for="auto-mod" aria-label="close sidebar" class="drawer-overlay" @click.stop="isOpenAutoMod = false"></label>
                <div class="bg-base-100 text-base-content min-h-full w-80 md:w-96" v-if="isOpenAutoMod" @click.stop>
                    <div class="sticky top-0 bg-base-100 z-10 p-4 border-b border-base-200">
                        <div class="flex items-center justify-between">
                            <h3 class="text-lg font-semibold flex items-center">
                                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                </svg>
                                自动刮削配置
                            </h3>
                            <button class="btn btn-circle btn-ghost btn-sm" @click="isOpenAutoMod = false">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                    
                    <div class="p-4 space-y-6">
                        <div class="bg-info/10 p-4 rounded-lg border border-info/20">
                            <div class="text-sm text-base-content/80 space-y-1">
                                <p>根据元数据中的标题、艺术家、专辑和文件名、文件完整路径进行匹配。</p>
                                <p>标题、艺术家、专辑每一项匹配等级指标：完全一致，包含，不匹配</p>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">匹配模式</span>
                            </label>
                            <div class="space-y-2">
                                <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                    <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="simple"
                                        v-model="formData.silent_select_mode" @change="updateSys('silent_select_mode')" />
                                    <div class="flex-1">
                                        <div class="font-medium">宽松模式</div>
                                        <div class="text-xs text-base-content/70">满足标题包含即可，但也优先选完全一致</div>
                                    </div>
                                </label>
                                <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                    <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="normal"
                                        v-model="formData.silent_select_mode" @change="updateSys('silent_select_mode')" />
                                    <div class="flex-1">
                                        <div class="font-medium">标准模式</div>
                                        <div class="text-xs text-base-content/70">三个指标必须为包含或完全一致，但也优先选完全一致</div>
                                    </div>
                                </label>
                                <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                    <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="hard"
                                        v-model="formData.silent_select_mode" @change="updateSys('silent_select_mode')" />
                                    <div class="flex-1">
                                        <div class="font-medium">严格模式</div>
                                        <div class="text-xs text-base-content/70">三个指标必须都为完全一致</div>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">音乐源顺序</span>
                            </label>
                            <multi-select :options="resourceListBatch" v-model="formData.silence_source_list"
                                @change="updateSys('silence_source_list')">
                            </multi-select>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">修改范围</span>
                            </label>
                            <multi-select :options="modifyListBatch" v-model="formData.silence_modify_list"
                                @change="updateSys('silence_modify_list')">
                            </multi-select>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4">
                                <span class="label-text font-medium">跳过匹配</span>
                                <input type="checkbox" class="toggle toggle-primary" 
                                    @change="updateSys('silence_is_skip_tag')" v-model="formData.silence_is_skip_tag" />
                            </label>
                            <div class="mt-2 p-3 bg-base-200/50 rounded-lg">
                                <div class="text-sm text-base-content/70">
                                    如修改范围中元数据都存在，则跳过匹配，原有音乐标签将被保留，不会被修改或覆盖
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4">
                                <span class="label-text font-medium">同目录解释为同个专辑</span>
                                <input type="checkbox" class="toggle toggle-primary" 
                                    @change="updateSys('silence_is_folder_album')" v-model="formData.silence_is_folder_album" />
                            </label>
                            <div class="mt-2 p-3 bg-base-200/50 rounded-lg">
                                <div class="text-sm text-base-content/70">
                                    当元数据中不存在专辑信息，用于补充专辑信息，提高匹配度
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 手动刮削抽屉 -->
        <div class="drawer drawer-end">
            <input id="manual-mod" type="checkbox" class="drawer-toggle" v-model="isOpenManualMod" />
            <div class="drawer-content">
            </div>
            <div class="drawer-side" style="z-index: 1000;">
                <label for="manual-mod" aria-label="close sidebar" class="drawer-overlay" @click.stop="isOpenManualMod = false"></label>
                <div class="bg-base-100 text-base-content min-h-full w-80 md:w-96" v-if="isOpenManualMod" @click.stop>
                    <div class="sticky top-0 bg-base-100 z-10 p-4 border-b border-base-200">
                        <div class="flex items-center justify-between">
                            <h3 class="text-lg font-semibold flex items-center">
                                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                                </svg>
                                手动刮削配置
                            </h3>
                            <button class="btn btn-primary btn-sm gap-1" @click="handleSaveManualMusic">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                                保存并关闭
                            </button>
                        </div>
                    </div>
                    
                    <div class="p-4">
                        <music-meta-data :music-info="formData.silence_music_info" :reload-img="reloadImg"
                            :drawer-mode="'drawer'" :mode="'form'">
                        </music-meta-data>
                    </div>
                </div>
            </div>
        </div>

        <!-- 文件整理抽屉 -->
        <div class="drawer drawer-end">
            <input id="tidy-music" type="checkbox" class="drawer-toggle" v-model="isOpenTidyMusic" />
            <div class="drawer-content">
            </div>
            <div class="drawer-side" style="z-index: 1000;">
                <label for="tidy-music" aria-label="close sidebar" class="drawer-overlay" @click.stop="isOpenTidyMusic = false"></label>
                <div class="bg-base-100 text-base-content min-h-full w-80 md:w-96" v-if="isOpenTidyMusic" @click.stop>
                    <div class="sticky top-0 bg-base-100 z-10 p-4 border-b border-base-200">
                        <div class="flex items-center justify-between">
                            <h3 class="text-lg font-semibold flex items-center">
                                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
                                </svg>
                                文件整理配置
                            </h3>
                            <button class="btn btn-circle btn-ghost btn-sm" @click="isOpenTidyMusic = false">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                    
                    <div class="p-4 space-y-6">
                        <div class="bg-info/10 p-4 rounded-lg border border-info/20">
                            <div class="text-sm text-base-content/80">
                                整理文件夹，按一级目录，二级目录选定的信息分类
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">整理后的根目录</span>
                            </label>
                            <input type="text" placeholder="请输入根目录路径" 
                                class="input input-bordered focus:input-accent w-full"
                                v-model="formData.root_path" @change="updateSys('root_path')" />
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">目录层级设置</span>
                            </label>
                            <div class="space-y-3">
                                <div v-for="(input, index) in formData.dir_list" :key="index" 
                                    class="p-3 border border-base-200 rounded-lg">
                                    <div class="flex items-center justify-between mb-2">
                                        <span class="text-sm font-medium">第{{ index + 1 }}层目录</span>
                                        <button class="btn btn-circle btn-ghost btn-xs text-error" 
                                            @click="removeInput(index)">
                                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                            </svg>
                                        </button>
                                    </div>
                                    <single-select v-model="input.value" :options="tidyList"
                                        :placeholder="'请选择'" @change="updateSys('dir_list')">
                                    </single-select>
                                    <div v-if="input.value === 'custom'" class="mt-2">
                                        <label class="label">
                                            <span class="label-text text-sm">自定义变量</span>
                                        </label>
                                        <input type="text" placeholder="请输入自定义变量，例如：${artist}-${album}"
                                            class="input input-sm input-bordered w-full"
                                            v-model="input.value2" @change="updateSys('dir_list')" />
                                    </div>
                                </div>
                                <button class="btn btn-outline btn-sm gap-2 w-full" @click="addInput">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                                    </svg>
                                    添加目录层级
                                </button>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4">
                                <span class="label-text font-medium">启用音乐洗版</span>
                                <input type="checkbox" class="toggle toggle-warning" 
                                    v-model="formData.is_clean_music" @change="updateSys('is_clean_music')" />
                            </label>
                            <div class="mt-2 p-3 bg-warning/10 rounded-lg border border-warning/20">
                                <div class="text-sm text-base-content/80">
                                    音乐洗版就是按以下规则换更好的版本
                                </div>
                            </div>
                        </div>

                        <div v-if="formData.is_clean_music" class="space-y-4 p-4 bg-base-200/50 rounded-lg border border-base-200">
                            <h4 class="font-medium text-base-content">洗版规则配置</h4>
                            
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">格式优先级</span>
                                </label>
                                <multi-select :options="formatList" v-model="formData.clean_format_priority" 
                                    @change="updateSys('clean_format_priority')">
                                </multi-select>
                            </div>
                            
                            <div class="grid grid-cols-1 gap-4">
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">文件大小规则</span>
                                    </label>
                                    <single-select v-model="formData.clean_size_rule" :options="sizeRuleList" 
                                        :placeholder="'请选择'" @change="updateSys('clean_size_rule')">
                                    </single-select>
                                </div>
                                
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">比特率规则</span>
                                    </label>
                                    <single-select v-model="formData.clean_bitrate_rule" :options="bitRuleList" 
                                        :placeholder="'请选择'" @change="updateSys('clean_bitrate_rule')">
                                    </single-select>
                                </div>
                                
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">采样率/位深规则</span>
                                    </label>
                                    <single-select v-model="formData.clean_sample_rule" :options="sampleRuleList" 
                                        :placeholder="'请选择'" @change="updateSys('clean_sample_rule')">
                                    </single-select>
                                </div>
                                
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">文件名规则</span>
                                    </label>
                                    <single-select v-model="formData.clean_name_rule" :options="nameRuleList" 
                                        :placeholder="'请选择'" @change="updateSys('clean_name_rule')">
                                    </single-select>
                                </div>
                                
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">删除策略</span>
                                    </label>
                                    <single-select v-model="formData.clean_delete_rule" :options="deleteRuleList" 
                                        :placeholder="'请选择'" @change="updateSys('clean_delete_rule')">
                                    </single-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MusicMetaData from '@/views/home/musicMetaData'
import SingleSelect from "@/components/iview/SingleSelect";
import MultiSelect from "@/components/iview/MultiSelect";
import SvgIcon from '@/components/SvgIcon.vue'

export default {
    name: 'BackgroundScraping',
    components: {
        SingleSelect,
        MusicMetaData,
        MultiSelect,
        SvgIcon
    },
    props: {
        formData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            preDataCollapse: true,
            autoModCollapse: true,
            tidyCollapse: true,
            isOpenAutoMod: false,
            isOpenManualMod: false,
            isOpenTidyMusic: false,
            reloadImg: false,
            celeryTaskLastTime: '',
            modifyListBatch: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'albumartist', name: '专辑艺术家' },
                { id: 'album_img', name: '专辑封面' },
                { id: 'year', name: '年份' },
                { id: 'lyrics', name: '歌词' },
                { id: 'is_save_lyrics_file', name: '歌词(LRC文件)' },
                { id: 'discnumber', name: '光盘编号' },
                { id: 'tracknumber', name: '音轨号' },
                { id: 'composer', name: '作曲家' },
                { id: 'lyricist', name: '作词家' },
                { id: 'language', name: '语言' }
            ],
            tidyList: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'album_artist', name: '专辑艺术家' },
                { id: 'album_type', name: '专辑类型' },
                { id: 'genre', name: '风格' },
                { id: 'language', name: '语言' },
                { id: 'track_number', name: '音轨号' },
                { id: 'disc_number', name: '光盘编号' },
                { id: 'comment', name: '描述' },
                { id: 'custom', name: '自定义' }
            ],
            resourceListBatch: [
                { id: 'netease', name: '网易云音乐' },
                { id: 'migu', name: '咪咕音乐' },
                { id: 'qmusic', name: 'QQ音乐' },
                { id: 'kugou', name: '酷狗音乐' },
                { id: 'kuwo', name: '酷我音乐' },
                { id: 'itunes', name: 'iTunes' },
                { id: 'spotify', name: 'Spotify' },
                { id: 'musicbrainz', name: 'MusicBrainz' },
            ],
            sizeRuleList: [
                { 'id': 'larger', 'name': '删除较大文件' },
                { 'id': 'smaller', 'name': '删除较小文件' },
                { 'id': 'none', 'name': '不判断' },
            ],
            bitRuleList: [
                { 'id': 'larger', 'name': '删除较大比特率' },
                { 'id': 'smaller', 'name': '删除较小比特率' },
                { 'id': 'none', 'name': '不判断' },
            ],
            sampleRuleList: [
                { 'id': 'larger', 'name': '删除较大采样率' },
                { 'id': 'smaller', 'name': '删除较小采样率' },
                { 'id': 'none', 'name': '不判断' },
            ],
            nameRuleList: [
                { 'id': 'larger', 'name': '删除含有后缀名' },
                { 'id': 'smaller', 'name': '删除不含有后缀名' },
                { 'id': 'none', 'name': '不判断' },
            ],
            formatList: [
                { id: 'mp3', name: 'MP3' },
                { id: 'wav', name: 'WAV' },
                { id: 'flac', name: 'FLAC' },
                { id: 'wma', name: 'WMA' },
                { id: 'ogg', name: 'OGG' }
            ],
            deleteRuleList: [
                { 'id': 'delete', 'name': '删除' },
                { 'id': 'move', 'name': '移动' },
            ]
        }
    },
    mounted() {
        this.fetchCeleryTaskLastTime()
    },
    watch: {
    },
    methods: {
        updateSys(key) {
            this.$emit('update-sys', key)
        },
        redirectEditDetail(path) {
            this.$emit('redirect-edit', path)
        },
        handleBackendExe() {
            this.$api.Task.debugTask2({ 'mode': 'backend_exe' }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '执行成功！',
                        type: 'success',
                        time: 2000,
                    })
                }
            })
        },
        fetchCeleryTaskLastTime() {
            this.$api.Task.celeryTaskLastTime().then((res) => {
                if (res.result) {
                    this.celeryTaskLastTime = res.data.last_run_at
                }
            })
        },
        handleSaveManualMusic() {
            this.isOpenManualMod = false
            this.updateSys('silence_music_info')
        },
        addInput() {
            this.formData.dir_list.push({ value: '' })
        },
        removeInput(index) {
            this.formData.dir_list.splice(index, 1)
            this.updateSys('dir_list')
        },
        toggleCollapse(collapse) {
            this[collapse] = !this[collapse]
        },
        openAutoModConfig() {
            this.isOpenAutoMod = true
        },
        openManualModConfig() {
            this.isOpenManualMod = true
        },
        openTidyMusicConfig() {
            this.isOpenTidyMusic = true
        }
    }
}
</script> 